import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Flex } from 'antd';
import Document from '../pdf/Document';
import useHelpers from '../../hooks/context/useHelpers';

export default function SignedContract({ data, className }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Contract:SignedContract' });
  const { formatDate } = useHelpers();

  const [contractFile, setContractFile] = useState(null);
  const [loadingFile, setLoadingFile] = useState(false);
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    loadContractFile();
  }, []);

  async function loadContractFile() {
    if (!data.file_url) {
      return;
    }

    setLoadingFile(true);
    setLoadFailed(false);

    // A dropped connection or a blocking browser extension rejects the fetch; show a retry
    // instead of leaving an empty viewer and an unhandled rejection.
    return fetch(data.file_url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Contract file request failed with ${response.status}`);
        }

        return response.blob();
      })
      .then((blob) => setContractFile(blob))
      .catch(() => setLoadFailed(true))
      .finally(() => setLoadingFile(false));
  }

  return (
    <Flex justify="center" vertical className={className}>
      {loadFailed ? (
        <Alert
          type="warning"
          showIcon
          title={t('errors.load_failed')}
          action={
            <Button size="small" onClick={loadContractFile}>
              {t('buttons.retry')}
            </Button>
          }
          className="mx-auto"
        />
      ) : (
        <Document key={data?.file_url} file={contractFile} loading={loadingFile} className="mx-auto" />
      )}
      <h5 className="mt-lg mx-auto">
        {data.signed_at
          ? t('labels.signed_by', {
              name: data.signed_by,
              date: formatDate(data.signed_at),
            })
          : t('labels.signed_by_no_date', { name: data.signed_by })}
      </h5>
    </Flex>
  );
}
